export default __webpack_public_path__ + "static/media/delete-icon.2f3e46ba.svg";